import React, { useState, useEffect } from "react";
import "./detailedProperty.css";
import Logo from "../../../assets/logotipo secundario - alfa tabelas.png";
import { useNavigate, useLocation, Link, useParams } from "react-router-dom";
import Modal from "../../components/Modal";
import { getRealEstate } from "../../../services/api/real_estates";
import ModalConfirmAction from "../../components/ModalConfirmAction";
import {
  deletePropertie,
  getPropertieById,
} from "../../../services/api/properties";
import {
  FaRegStar,
  FaStar,
  FaMapMarkerAlt,
  FaBed,
  FaSwimmingPool,
  FaWhatsapp,
  FaLink,
  FaDownload,
  FaShareSquare,
  FaTrashAlt,
  FaCar,
  FaUmbrellaBeach,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { MdBathroom, MdEdit } from "react-icons/md";
import { GiBed, GiBarbecue } from "react-icons/gi";
import { RiSofaFill } from "react-icons/ri";
import { TbBeach, TbCashRegister } from "react-icons/tb";
import { AiFillLike } from "react-icons/ai";
import { jwtDecode } from "jwt-decode";
import {
  removeFavorite,
  addFavorite,
} from "../../../services/api/user_favorites";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import generatePDF, { Margin } from "react-to-pdf";
import { formatMoney } from "../../../utils/formatMoney";

export default function DetailedProperty() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();

  const [property, setProperty] = useState(location.state?.property || null);
  const [loading, setLoading] = useState(!location.state?.property);
  const [responsibleName, setResponsibleName] = useState("Carregando...");
  const [copyFeedback, setCopyFeedback] = useState("Copiar Link do Drive");
  const [currentUser] = useState(() => {
    const token = localStorage.getItem("token");
    if (!token) return { nivel: null };
    try {
      const decodedToken = jwtDecode(token);
      return { nivel: decodedToken?.position || null };
    } catch (error) {
      console.error("Failed to decode token:", error);
      return { nivel: null };
    }
  });

  const contextData = location.state?.contextData || [];
  const currentIndex = property
    ? contextData.findIndex((p) => p.id === property.id)
    : -1;

  const hasPrev = currentIndex > 0;
  const hasNext = currentIndex !== -1 && currentIndex < contextData.length - 1;

  const handleNavigateProperty = (direction) => {
    if (currentIndex === -1) return;

    const newIndex = direction === "next" ? currentIndex + 1 : currentIndex - 1;
    const newProperty = contextData[newIndex];

    if (newProperty) {
      setProperty(newProperty);

      navigate(`/dashboard/imoveis/${newProperty.id}`, {
        state: {
          ...location.state,
          property: newProperty,
          contextData: contextData,
        },
        replace: true,
      });
    }
  };

  const [userFavorites, setUserFavorites] = useState([]);
  const [propertyToDelete, setPropertyToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const mesesMap = {
    1: "Janeiro",
    2: "Fevereiro",
    3: "Março",
    4: "Abril",
    5: "Maio",
    6: "Junho",
    7: "Julho",
    8: "Agosto",
    9: "Setembro",
    10: "Outubro",
    11: "Novembro",
    12: "Dezembro",
  };

  useEffect(() => {
    if (property && property.real_estate_id) {
      const fetchResponsibleName = async () => {
        try {
          const realEstateData = await getRealEstate(property.real_estate_id);
          const name =
            realEstateData.nomeFantasia ||
            realEstateData.nome ||
            realEstateData.razaoSocial ||
            realEstateData.full_name ||
            "Não informado";
          setResponsibleName(name);
        } catch (error) {
          console.error("Erro ao buscar dados do responsável:", error);
          setResponsibleName("Não informado");
        }
      };
      fetchResponsibleName();
    } else {
      setResponsibleName("Não informado");
    }
  }, [property]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        event.target.tagName === "INPUT" ||
        event.target.tagName === "TEXTAREA" ||
        showDeleteModal
      ) {
        return;
      }

      if (event.key === "ArrowLeft" && hasPrev) {
        handleNavigateProperty("prev");
      } else if (event.key === "ArrowRight" && hasNext) {
        handleNavigateProperty("next");
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [hasPrev, hasNext, currentIndex, showDeleteModal]);

  useEffect(() => {
    if (location.state?.property) {
      setProperty(location.state.property);
      return;
    }

    const fetchProperty = async () => {
      setLoading(true);
      try {
        const data = await getPropertieById(id);
        setProperty(data);
      } catch (error) {
        console.error("Erro ao buscar dados do imóvel:", error);
        setProperty(null);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchProperty();
    }
  }, [id, location.state]);

  const checkFeature = (key, textTerms = []) => {
    if (!property) return false;

    if (property[key] === true || property[key] === "true") return true;

    if (property.outrasInfo && textTerms.length > 0) {
      const infoLower = property.outrasInfo.toLowerCase();
      return textTerms.some((term) => infoLower.includes(term.toLowerCase()));
    }
    return false;
  };

  if (loading) {
    return <div>Carregando detalhes do imóvel...</div>;
  }

  if (!property) {
    return <div>Imóvel não encontrado.</div>;
  }

  const formatPhoneNumber = (phoneString) => {
    if (!phoneString || typeof phoneString !== "string") return "";
    const digitsOnly = phoneString.replace(/\D/g, "");
    const relevantDigits = digitsOnly.startsWith("0")
      ? digitsOnly.slice(1)
      : digitsOnly;
    const length = relevantDigits.length;
    if (length === 11)
      return `(${relevantDigits.slice(0, 2)}) ${relevantDigits.slice(
        2,
        7,
      )}-${relevantDigits.slice(7)}`;
    if (length === 10)
      return `(${relevantDigits.slice(0, 2)}) ${relevantDigits.slice(
        2,
        6,
      )}-${relevantDigits.slice(6)}`;
    return phoneString;
  };

  const copyLinkToClipboard = () => {
    if (!property.drivelinks) return;
    navigator.clipboard
      .writeText(property.drivelinks.replace(/[{}]/g, "").trim())
      .then(() => {
        setCopyFeedback("Copiado!");
        setTimeout(() => setCopyFeedback("Copiar Link do Drive"), 2000);
      })
      .catch((err) => {
        console.error("Falha ao copiar o link: ", err);
        alert("Não foi possível copiar o link.");
      });
  };

  const toggleFavorite = (id) => {
    const isFavorited = userFavorites.includes(id);
    if (isFavorited) {
      removeFavorite(id);
      setUserFavorites(userFavorites.filter((favId) => favId !== id));
    } else {
      addFavorite(id);
      setUserFavorites([...userFavorites, id]);
    }
  };

  const handleClose = () => {
    const scrollPosition = location.state?.scrollPosition || 0;
    navigate(-1);
    setTimeout(() => {
      window.scrollTo(0, scrollPosition);
    }, 0);
  };

  const handleDeleteProperty = (id) => {
    deletePropertie(id)
      .then(() => {
        alert("Imóvel excluído com sucesso!");
        navigate("/dashboard", { replace: true });
      })
      .catch((error) => {
        console.error("Erro ao excluir imóvel:", error);
        alert("Erro ao excluir o imóvel. Tente novamente.");
      });
  };

  const formatarComissao = (valor) => {
    if (valor === null || valor === undefined || valor === "") {
      return "Não Informado";
    }
    const numValor = parseFloat(valor);
    if (numValor === 0 || Number(valor) === 999) {
      return "Fifty";
    }
    const v = String(valor).trim().toLowerCase();
    if (v === "fifty") {
      return "Fifty";
    }
    const num = parseFloat(v);
    if (isNaN(num)) {
      return valor;
    }
    if (num > 0 && num < 1) {
      return `${(num * 100).toFixed(0)}%`;
    }
    return `${num}%`;
  };

  const barOptionsOfModal = () => {
    const configToPdf = {
      filename: `ALFA_TABELAS_IMÓVEL_${
        property.dorms
      }_DORMITÓRIO(s)_${property.bairro?.toUpperCase()}_${property.id}`,
      method: "save",
      page: { margin: Margin.MEDIUM, format: "A4", orientation: "portrait" },
    };

    const createArchivePdf = () => document.getElementById("contentToPdf");

    const sharePropertyOfWpp = () => {
      const message = `*ALFA TABELAS*\n\n*${
        property.tipoImovel === "Apartamento" ? "APTO." : "CASA"
      } ${property.dorms} ${
        property.dorms > 1 ? "DORMITÓRIOS" : "DORMITÓRIO"
      } - ${
        property.nomeResidencial
          ? property.nomeResidencial.toUpperCase() + " - "
          : ""
      }${property.bairro?.toUpperCase()}*\n\n*ENDEREÇO DO IMÓVEL*\n📍 ${address}\n${`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        address,
      )}`}\n\n*VALORES E MÉTODOS DE PAGAMENTOS*\n\n💰 Valor à vista: ${
        property.valor ? formatMoney(property.valor) : "Não Informado"
      }\n${
        property.condominio > 0
          ? `Condomínio: ${formatMoney(property.condominio)}\n`
          : ""
      }💰 IPTU: ${
        property.iptu ? formatMoney(property.iptu) : "Não Informado"
      }\n${
        property.outrasInfo?.includes("Permuta") ? `✅ Aceita Permuta\n` : ""
      }${
        property.financiamentoDireto
          ? `✅ Aceita Financiamento Direto`
          : "❌ Não Aceita Financiamento Direto"
      }\n${
        property.financiamentoDireto
          ? `💰 Valor com Financiamento Direto: ${
              property.valorFinanciamentoDireto
                ? formatMoney(property.valorFinanciamentoDireto)
                : "Não informado"
            }\n`
          : ""
      }${
        property.financiamentoDireto && property.info_condicao_financiamento
          ? `ℹ️ Condições do Financiamento: ${property.info_condicao_financiamento}\n`
          : ""
      }\n\n*OUTRAS INFORMAÇÕES*\n\n📈 Comissão: ${
        property.comissao === "Fifty" ? "Fifty" : `${property.comissao}%`
      }\n🗝️ Localização das chaves para visitação: ${
        property.chaves || "Não informado"
      }\n`;
      const whatsappLink = `https://api.whatsapp.com/send?text=${encodeURIComponent(
        message,
      )}`;
      window.open(whatsappLink, "_blank");
    };

    const cleanDriveLink = property.drivelinks
      ? property.drivelinks.replace(/[{}]/g, "").trim()
      : "";

    return (
      <>
        <Link to={"/dashboard/"} className="logo-bar-options">
          <img src={Logo} alt="Logo Alfa Tabelas"></img>
        </Link>
        <div className="bts-bar-options">
          <i
            className={`bt-fav ${
              userFavorites.includes(property.id) ? "favorited" : ""
            }`}
            onClick={() => toggleFavorite(property.id)}
            title="Favoritar Imóvel"
          >
            {userFavorites.includes(property.id) ? <FaStar /> : <FaRegStar />}
          </i>
          <i
            onClick={() => generatePDF(createArchivePdf, configToPdf)}
            title="Baixar Arquivo em Pdf"
          >
            <FaDownload />
          </i>
          {cleanDriveLink.length > 0 && (
            <i onClick={copyLinkToClipboard} title={copyFeedback}>
              <FaLink />
            </i>
          )}
          <i onClick={sharePropertyOfWpp} title="Compartilhar Imóvel">
            <FaShareSquare />
          </i>

          {(currentUser?.nivel === "admin" ||
            currentUser?.nivel === "editor" ||
            currentUser?.nivel === "assistant") && (
            <>
              <i
                onClick={() =>
                  navigate(
                    `/dashboard/adicionar-imovel/?propertyId=${property.id}`,
                  )
                }
                title="Editar Imóvel"
              >
                <MdEdit />
              </i>
              <i
                onClick={() => {
                  setPropertyToDelete(property.id);
                  setShowDeleteModal(true);
                }}
                title="Remover Imóvel"
              >
                <FaTrashAlt />
              </i>
            </>
          )}
        </div>
      </>
    );
  };

  const address =
    property && property.logradouro
      ? `${property.logradouro} ${property.numero || "S/N"}, ${
          property.complemento || "Sem complemento"
        } - ${property.bairro || "Sem bairro"}, ${
          property.cidade || "Sem cidade"
        }/${property.estado || "Sem estado"}, ${
          property.cep === "00000000" ||
          property.cep === "00000-000" ||
          !property.cep
            ? "Sem CEP"
            : property.cep
        }`
      : "Endereço não disponível";

  return (
    <div className="container-detailed-property">
      {contextData.length > 0 && (
        <>
          {hasPrev && (
            <button
              className="floating-arrow arrow-left"
              onClick={() => handleNavigateProperty("prev")}
              title="Imóvel Anterior"
            >
              <FaChevronLeft />
            </button>
          )}

          {hasNext && (
            <button
              className="floating-arrow arrow-right"
              onClick={() => handleNavigateProperty("next")}
              title="Próximo Imóvel"
            >
              <FaChevronRight />
            </button>
          )}

          <div className="desktop-nav-info">
            <p>
              Imóvel {currentIndex + 1} de {contextData.length}
            </p>
          </div>
        </>
      )}
      <Modal
        isOpen={true}
        otherClassBarOptions="bar-options-complements-detailed-propety"
        barOptionsComplements={barOptionsOfModal()}
        title="Detalhes do Imóvel"
        onClose={handleClose}
        id="contentToPdf"
      >
        <section className="container-details">
          {contextData.length > 0 && (
            <div className="mobile-property-navigation">
              <button
                className={`mobile-nav-btn ${!hasPrev ? "disabled" : ""}`}
                onClick={() => hasPrev && handleNavigateProperty("prev")}
                disabled={!hasPrev}
              >
                <FaChevronLeft /> Anterior
              </button>

              <span className="mobile-nav-info">
                {currentIndex + 1} de {contextData.length}
              </span>

              <button
                className={`mobile-nav-btn ${!hasNext ? "disabled" : ""}`}
                onClick={() => hasNext && handleNavigateProperty("next")}
                disabled={!hasNext}
              >
                Próximo <FaChevronRight />
              </button>
            </div>
          )}
          <Swiper
            key={property.id}
            modules={[Navigation, Pagination, A11y]}
            slidesPerView={1}
            pagination={{ clickable: true }}
            navigation
          >
            {property.imagens &&
              property.imagens.map((item, i) => (
                <SwiperSlide key={item.id || i}>
                  <img
                    src={item.url || item}
                    alt={`Slide ${i + 1}`}
                    className="slide-item"
                  />
                </SwiperSlide>
              ))}
            <SwiperSlide
              style={{
                width: "100%",
                height: "100%",
                textAlign: "center",
                alignContent: "center",
              }}
            >
              <button
                type="button"
                className="carousel-more-images"
                onClick={() => {
                  const driveLink = property.drivelinks
                    ? property.drivelinks.replace(/[{}]/g, "").trim()
                    : "";

                  if (driveLink) {
                    window.open(driveLink, "_blank", "noopener,noreferrer");
                  } else {
                    alert("SEM LINKS PARA DRIVE");
                  }
                }}
              >
                {property.drivelinks &&
                property.drivelinks.replace(/[{}]/g, "").trim() !== ""
                  ? "VER MAIS IMAGENS"
                  : "SEM LINKS PARA DRIVE"}
                <div className="carousel-more-images-overlay"></div>
              </button>
            </SwiperSlide>
          </Swiper>
          <h2>
            {property.tipoImovel === "Apartamento"
              ? `APTO. `
              : `${property.tipoImovel?.toUpperCase()} `}
            {property.dorms
              ? property.dorms === 1
                ? `${property.dorms} DORMITÓRIO - `
                : `${property.dorms} DORMITÓRIOS - `
              : ""}
            {property.nomeResidencial
              ? `${property.nomeResidencial.toUpperCase()} `
              : ""}
            {property.bairro ? `- ${property.bairro.toUpperCase()}` : ""}
            {property.statusImovel !== "Venda"
              ? ` - (${property.statusImovel.toUpperCase()})`
              : ""}
          </h2>
          <div className="information-field">
            <h3>INFORMAÇÕES DO IMÓVEL</h3>
            <div className="wing-default">
              <span>Endereço do imóvel: </span>
              <a
                className="wing-adress"
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                  address,
                )}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i>
                  <FaMapMarkerAlt />
                </i>
                <p>{address}</p>
              </a>
            </div>
            <div
              className="wing-default"
              style={
                property.nomeResidencial === ""
                  ? { display: "none" }
                  : { display: "flex" }
              }
            >
              <span>Nome do condomínio: </span>
              <p>{property.nomeResidencial}</p>
            </div>
            <div className="wing-default">
              <span>Área do imóvel (m²): </span>
              <p>{property.area} m²</p>
            </div>
          </div>
          <div className="information-field">
            <h3>VALORES DO IMÓVEL</h3>
            <div className="wing-default">
              <span>Valor: </span>
              <p>
                {property.valor ? formatMoney(property.valor) : "Não Informado"}
              </p>
            </div>
            <span className="wing-default">
              <span>Aceita Financiamento Direto?</span>
              <p>{property.financiamentoDireto ? "Sim" : "Não"}</p>
            </span>
            <span
              className="wing-default"
              style={
                property.financiamentoDireto
                  ? { display: "flex" }
                  : { display: "none" }
              }
            >
              <span>Condição com Financiamento Direto:</span>
              <p>
                {property.financiamentoDireto
                  ? `${
                      property.valorFinanciamentoDireto
                        ? formatMoney(property.valorFinanciamentoDireto)
                        : "Não Informado"
                    } ${
                      property.parcelasFinanciamentoDireto
                        ? `/ ${property.parcelasFinanciamentoDireto} parcelas`
                        : ""
                    } `
                  : "Não Informado"}
              </p>
            </span>
            {property.financiamentoDireto &&
              property.info_condicao_financiamento && (
                <div className="wing-default" style={{ display: "flex" }}>
                  <span>Informações Adicionais do Financiamento:</span>
                  <p style={{ whiteSpace: "pre-wrap" }}>
                    {property.info_condicao_financiamento}
                  </p>
                </div>
              )}
            <div className="wing-default">
              <span>IPTU: </span>
              <p>
                {property.iptu ? formatMoney(property.iptu) : "Não Informado"}
              </p>
            </div>
            <div
              className="wing-default"
              style={
                property.condominio &&
                parseFloat(
                  String(property.condominio)
                    .replace(/[R$.]/g, "")
                    .replace(",", "."),
                ) > 0
                  ? { display: "flex" }
                  : { display: "none" }
              }
            >
              <span>Condominio: </span>
              <p>
                {property.condominio
                  ? formatMoney(property.condominio)
                  : "Não Informado"}
              </p>
            </div>
          </div>

          <div className="features-field">
            <h3>CARACTERÍSTICAS DO IMÓVEL</h3>
            <div className="wing-features">
              {property.dorms > 0 && (
                <span className="seal-feature">
                  <i>
                    <FaBed />
                  </i>
                  <p>
                    {property.dorms === 1
                      ? `${property.dorms} DORMITÓRIO`
                      : `${property.dorms} DORMITÓRIOS`}
                  </p>
                </span>
              )}

              {property.banheiros > 0 && (
                <span className="seal-feature">
                  <i>
                    <MdBathroom />
                  </i>
                  <p>
                    {property.banheiros > 1
                      ? `${property.banheiros} BANHEIROS`
                      : `${property.banheiros} BANHEIRO`}
                  </p>
                </span>
              )}

              {property.suites > 0 && (
                <span className="seal-feature">
                  <i>
                    <GiBed />
                  </i>
                  <p>
                    {property.suites > 1
                      ? `${property.suites} SUÍTES`
                      : `${property.suites} SUÍTE`}
                  </p>
                </span>
              )}

              {property.garagens > 0 && (
                <span className="seal-feature">
                  <i>
                    <FaCar />
                  </i>
                  <p>
                    {property.garagens > 1
                      ? `${property.garagens} GARAGENS`
                      : `${property.garagens} GARAGEM`}
                  </p>
                </span>
              )}

              {checkFeature("has_full_leisure", ["Lazer Completo"]) && (
                <span className="seal-feature">
                  <i>
                    <AiFillLike />
                  </i>
                  <p>LAZER COMPLETO</p>
                </span>
              )}

              {checkFeature("has_pool", ["Piscina"]) && (
                <span className="seal-feature">
                  <i>
                    <FaSwimmingPool />
                  </i>
                  <p>PISCINA</p>
                </span>
              )}

              {checkFeature("is_furnished", ["Mobiliado"]) && (
                <span className="seal-feature">
                  <i>
                    <RiSofaFill />
                  </i>
                  <p>MOBILIADO</p>
                </span>
              )}

              {checkFeature("has_edicule", [
                "Com Edícula",
                "Edicula",
                "Edícula",
              ]) && (
                <span className="seal-feature">
                  <i>
                    <GiBarbecue />
                  </i>
                  <p>C/ EDÍCULA</p>
                </span>
              )}

              {checkFeature("is_seafront", ["Frente ao Mar", "Frente Mar"]) && (
                <span className="seal-feature">
                  <i>
                    <TbBeach />
                  </i>
                  <p>FRENTE AO MAR</p>
                </span>
              )}

              {checkFeature("has_sea_view", [
                "Vista ao Mar",
                "Vista para o Mar",
                "Vista Mar",
              ]) && (
                <span className="seal-feature">
                  <i>
                    <TbBeach />
                  </i>
                  <p>VISTA AO MAR</p>
                </span>
              )}

              {checkFeature("is_near_beach", [
                "Próximo a Praia",
                "Perto da Praia",
              ]) && (
                <span className="seal-feature">
                  <i>
                    <FaUmbrellaBeach />
                  </i>
                  <p>PRÓX. A PRAÍA</p>
                </span>
              )}

              {property.permuta && (
                <span className="seal-feature">
                  <i>
                    <TbCashRegister />
                  </i>
                  <p>PERMUTA</p>
                </span>
              )}
            </div>
          </div>
        </section>
        <section className="container-more-details">
          <div className="information-field">
            <h3>OUTRAS INFORMAÇÕES</h3>

            {property.anoEntregaImovel !== null &&
              property.anoEntregaImovel !== undefined && (
                <div className="wing-default">
                  <span>Entrega Prevista Para:</span>
                  <p>
                    {property.mesEntregaImovel
                      ? `${mesesMap[property.mesEntregaImovel]}/${property.anoEntregaImovel}`
                      : property.anoEntregaImovel}
                  </p>
                </div>
              )}

            <div className="wing-default">
              <span>Comissão (%):</span>
              <p>{formatarComissao(property.comissao)}</p>
            </div>
            <div className="wing-default">
              <span>Responsável:</span>
              <p>{responsibleName}</p>
            </div>
            <div className="wing-default">
              <span>Localização das Chaves:</span>
              <p>{property.chaves || "Não informado."}</p>
            </div>
            <div className="wing-default">
              <span>Outras Informações:</span>
              <p style={{ whiteSpace: "pre-wrap" }}>
                {property.outrasInfo || "Nenhuma outra informação."}
              </p>
            </div>
            <div className="wing-default">
              <span>Contatos:</span>
              {Array.isArray(property.contatos) &&
              property.contatos.length > 0 ? (
                property.contatos.map((contact, index) => {
                  const phoneNumber =
                    typeof contact === "object" && contact !== null
                      ? contact.cel
                      : contact;
                  const contactName =
                    typeof contact === "object" && contact !== null
                      ? contact.name
                      : null;
                  const cleanedPhoneNumber = String(phoneNumber).replace(
                    /\D/g,
                    "",
                  );
                  if (cleanedPhoneNumber) {
                    return (
                      <div className="wing-contact" key={index}>
                        <a
                          href={`https://wa.me/${cleanedPhoneNumber}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i>
                            <FaWhatsapp />
                          </i>
                          {contactName && <span>{contactName}: </span>}
                          <p>{formatPhoneNumber(phoneNumber)}</p>
                        </a>
                      </div>
                    );
                  }
                  return null;
                })
              ) : (
                <p>Não há contatos disponíveis.</p>
              )}
            </div>
          </div>
        </section>
      </Modal>

      {showDeleteModal && (
        <ModalConfirmAction
          isOpen={showDeleteModal}
          title="Confirmação de Exclusão de Imóvel"
          onClose={() => setShowDeleteModal(false)}
          descriptionAction="Tem certeza que deseja excluir o imóvel permanentemente?"
          buttonConfirmAction={() => {
            if (propertyToDelete) {
              handleDeleteProperty(propertyToDelete);
            }
            setShowDeleteModal(false);
          }}
          textButtonConfirmAction="DELETAR IMÓVEL"
          buttonCancelAction={() => setShowDeleteModal(false)}
          textButtonCancelAction="CANCELAR"
        />
      )}
    </div>
  );
}
